/**
 * 财务--》财务日记账 | 现金（银行）日记账
 */

export default {
  export_canPaste_upload: ['91720', '98380', '82635', '83046', '77038'], // 202506181749547074513, 财务日记账，客户可复制粘贴来上传图片，定制权限收敛
  // 历史问题，现金日记账页面表格需要主动调用表格filter   
  force_filter_in_cash_day_account: ['90100', '82635', '87503', '73803', '98285', '86341'], // 202410240934144109912、202506271328527102672
  journarl_add_lsxl_column:['96083','85780'], // 202507011704106004592,202506161626412808323,财务日记账 添加隶属线路列，以往工单202503031859295277404
  pay_account_type:['77335','98030'], // 202507301621495137984, 日记账，选择不同支付方式筛选支付账户中options https://imagecdn.ymm56.com/ymmfile/static/resource/5e7a3449-2916-4691-bd8e-ee4baa695e01.png
  summary_without_hyType:['72680'], // 202509231553496201853, 日记账 摘要不显示核销类型 https://imagecdn.ymm56.com/ymmfile/static/resource/a3120b26-69ca-4215-b384-df8d4954080c.png
  payment_requester:['90696'],//202508151753038031315 日记账添加请款人表单 https://imagecdn.ymm56.com/ymmfile/static/resource/51c11685-8905-4109-ac57-357d2432df82.png
  lrtype_2_payment_requester_gpy_type:['89325'],//202510111801338135154 管理费用请款单 高拍仪默认type为请款结果 https://imagecdn.ymm56.com/ymmfile/static/resource/ac7ec346-9b50-4eb9-817e-808b7c74386a.png
  create_journarl_with_batch_no:['84908'], // 202510201354426931177 84908, 请款结果生成日记账，新增批次号字段 https://imagecdn.ymm56.com/ymmfile/static/resource/2a56cb7d-2b5d-44f8-a787-8fe75ea77b1d.png
  create_journarl_with_associated_unit:['88114'], // 202510151206389901318 88114, 请款结果生成日记账，新增关联单号字段 https://imagecdn.ymm56.com/ymmfile/static/resource/1d2019dc-9180-4684-afce-5d51966d0487.png
  customized_operator:['80437'], // 202511041304274803875 80437, 定制操作人，默认值为夏群英
  get_result_img_in_type_1: ['86442'], // 202511131402552938443 进入银行存款日记账里 也带出请款结果的图片
  income_expenditure_offset_print_receipts:['78355','86980','82635'], // 202510291035412675226 收入支出抵消场景，按照收据打印对账单
  // 现金日记账必须上传图片
  cash_journal_must_upload_pic: ['84820'], // 202511261553166632473
  // 入账日期用前一天
  day_before_accounting_date: ['71907'], // 202512011336567639262
  cash_journal_cannot_select_future_date: ['86826'], // 202512011336567639262 现金日记账无法选择未来时间
  // 日记账支付方式必填
  cash_journal_pay_type_required: [], // 202601091056552173118 现金日记账支付方式必填
  // 日记账账户联动 定制从账户名维度带出支付方式、支付账号、开户行数据；同时取消 支付方式方向的联动
  cash_journal_account_linkage: ['85361'], // 202512091130197778325 现金日记账账户联动
  // 银行卡现金状态合并查询 202601231416357701883
  bank_cash_status_merge_query: ['73517','82635'], // 202601231416357701883 
  // 现金日记账备注高度定制
  cash_journal_remark_height: ['83972','90100'], // 202601231416357701883 
 }
